/**
 * The unanswered question holding the settle sheet's submit button, in
 * words (gdn-4176).
 *
 * Two answers are required before the sheet can submit, and both used to
 * block it silently: the button greyed out and nothing near it said why.
 * Island Life staff read that as "the charge is broken" (IL02). The
 * questions are asked in the body, often above the fold, so the footer
 * names the one still open.
 *
 * Only questions the biller can answer belong here. An amount that is
 * visibly empty explains itself, and a preview that is still loading has
 * its own state (gdn-3323).
 */
export interface SubmitBlockers {
  /** A new charge at account scope has no answer to "Which encounter is
   * this charge for?" (gdn-3086). */
  chargeAttributionMissing: boolean;
  /** A co-pay was declared, but no visit is chosen for it. */
  copayVisitMissing: boolean;
}

export const submitBlockedReasonOf = ({
  chargeAttributionMissing,
  copayVisitMissing,
}: SubmitBlockers): string | null => {
  if (chargeAttributionMissing) {
    return 'Answer “Which encounter is this charge for?” above to continue.';
  }
  if (copayVisitMissing) {
    // Switching to General payment is always available, and it is the
    // only way forward when there is no visit to choose.
    return 'Choose the visit this co-pay is for, or switch to General payment.';
  }
  return null;
};
